"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamChannelRole = exports.StreamChatRole = exports.StreamChannelType = void 0;
var StreamChannelType;
(function (StreamChannelType) {
    StreamChannelType["Group"] = "messaging-group";
    StreamChannelType["Private"] = "messaging-private";
    StreamChannelType["Audio"] = "messaging";
})(StreamChannelType = exports.StreamChannelType || (exports.StreamChannelType = {}));
var StreamChatRole;
(function (StreamChatRole) {
    StreamChatRole["Admin"] = "admin";
    StreamChatRole["User"] = "user";
})(StreamChatRole = exports.StreamChatRole || (exports.StreamChatRole = {}));
var StreamChannelRole;
(function (StreamChannelRole) {
    StreamChannelRole["ChannelModerator"] = "channel_moderator";
    StreamChannelRole["ChannelMember"] = "channel_member";
})(StreamChannelRole = exports.StreamChannelRole || (exports.StreamChannelRole = {}));
//# sourceMappingURL=stream.js.map